import React, { Component } from 'react'

import { connect } from 'react-redux';
import { reduxForm, change, reset } from 'redux-form';

import {
    GetDevicesDocsis,
    GetDevicesLocations,
    GetDevicesResidents,
    GetDevicesSerials
} from '../../actions/deviceActions';

//Material ui components
import { Button, Grid, } from '@material-ui/core'
import Popover from '@material-ui/core/Popover';
import Slide from '@material-ui/core/Slide';

//engage Components
import {
    LegacySimpleSelect
} from '../../utils/engageComponents';


const validate = (values) => {
};
export class DeviceFiltersDrawer extends Component {
    constructor(props) {
        super()
        this.state = {
            //filterObj
            filterObj: undefined,

            //ResidentFilter
            openResidentFilterSelect: false,
            ResidentSelected: undefined,

            //LocationFilter
            openZoneNameFilterSelect: false,
            ZoneNameSelected: undefined,

            //Device Filter (Serial number)
            openSerialNumberFilterSelect: false,
            SerialNumberSelected: undefined,

            openDocsisFilterSelect: false,
            docsisSelected: undefined,
        }

        props.dispatch(change('DeviceFiltersForm', 'FiltersResident', ''));
        props.dispatch(change('DeviceFiltersForm', 'FiltersZoneName', ''));
        props.dispatch(change('DeviceFiltersForm', 'FiltersSerialNumber', ''));
        props.dispatch(change('DeviceFiltersForm', 'FiltersDocsisSelected', ''));



    }

    componentDidMount = () => {
        window.addEventListener('resize', this.resize);

        if (this.props) {
            if (this.props.idAnchorEl) {
                this.setAnchorEl(this.props.idAnchorEl);
            }
        }

        const communityId = localStorage.getItem('communityId')
        
        this.props.GetDevicesLocations(communityId);
        this.props.GetDevicesSerials(communityId);
        this.props.GetDevicesResidents(communityId);
        this.props.GetDevicesDocsis(communityId)


    };

    componentWillUnmount = () => {
        window.removeEventListener('resize', this.resize);
    };

    resize = () => {
        if (this.props && this.props.idAnchorEl) {
            this.setAnchorEl(this.props.idAnchorEl)
        }
    };

    setAnchorEl(idAnchorEl) {
        const anchorEl = document.getElementById(idAnchorEl);

        if (anchorEl) {
            this.setState({ anchorEl: anchorEl })
        }
    };

    renderFilters(filterObj) {
        let residentSelected = undefined;
        let serialNumberSelected = undefined;
        let zoneNameSelected = undefined;
        let docsisSelected = undefined;


        if (filterObj.ResidentFilter) {
            residentSelected = this.props.residents.find(item => item === filterObj.ResidentFilter);
        }
        if (filterObj.SerialNumberFilter) {
            serialNumberSelected = this.props.serialNumbers.find(item => item === filterObj.SerialNumberFilter);
        }
        if (filterObj.zoneNameFilter) {
            zoneNameSelected = this.props.zoneNames.find(item => item === filterObj.zoneNameFilter);
        }

        if (filterObj.docsisFilter) {
            docsisSelected = this.props.docsis.find(item => item === filterObj.docsisFilter);
        }

        this.props.dispatch(change('DeviceFiltersForm', 'FiltersResident', residentSelected));
        this.props.dispatch(change('DeviceFiltersForm', 'FiltersSerialNumber', serialNumberSelected));
        this.props.dispatch(change('DeviceFiltersForm', 'FiltersZoneName', zoneNameSelected));
        this.props.dispatch(change('DeviceFiltersForm', 'FiltersDocsisSelected', docsisSelected));


        this.setState({
            ResidentSelected: { name: residentSelected },
            SerialNumberSelected: { name: serialNumberSelected },
            ZoneNameSelected: { name: zoneNameSelected },
            DocsisSelected:{ name: docsisSelected }
        });
    };


    //region Handlers
    handlerChangeOptionSelectedResidentName = (newResidentName) => {
        this.setState({ ResidentSelected: newResidentName })
    }

    handlerChangeOptionSelectedZoneName = (newFilterZoneName) => {
        this.setState({ ZoneNameSelected: newFilterZoneName })

    }

    handlerChangeOptionSelectedSerialNumber = (newSerialNumberSelected) => {
        this.setState({ SerialNumberSelected: newSerialNumberSelected })
    }

    handlerChangeOptionSelectedDocsis = (newDocsis) => {
        this.setState({ DocsisSelected: newDocsis })
    }

    handlerCleanFilters = () => {
        this.props.onFilterChange({});

        this.setState({
            //filterObj
            filterObj: undefined,

            //ResidentFilter
            openResidentFilterSelect: false,
            ResidentSelected: undefined,

            //LocationFilter
            openZoneNameFilterSelect: false,
            ZoneNameSelected: undefined,

            //Device Filter (Serial number)
            openSerialNumberFilterSelect: false,
            SerialNumberSelected: undefined,
            newFilterObj: undefined,

            openDocsisFilterSelect: false,
            DocsisSelected: undefined,
        });

        this.props.dispatch(reset('DeviceFiltersForm'));
        this.props.dispatch(change('DeviceFiltersForm', 'FiltersResident', ''));
        this.props.dispatch(change('DeviceFiltersForm', 'FiltersZoneName', ''));
        this.props.dispatch(change('DeviceFiltersForm', 'FiltersSerialNumber', ''));
        this.props.dispatch(change('DeviceFiltersForm', 'FiltersDocsisSelected', ''));


    }

    onSubmitHandler = (form) => {
        this.handlerCleanFilters();
    }


    handleApplyFilters = () => {
        try {
            const newFilters = {
                ResidentFilter: (this.state.ResidentSelected && this.state.ResidentSelected.name) ? this.state.ResidentSelected.name : undefined,
                SerialNumberFilter: (this.state.SerialNumberSelected && this.state.SerialNumberSelected.name) ? this.state.SerialNumberSelected.name : undefined,
                zoneNameFilter: (this.state.ZoneNameSelected && this.state.ZoneNameSelected.name) ? this.state.ZoneNameSelected.name : undefined,
                docsisFilter: (this.state.DocsisSelected && this.state.DocsisSelected.name) ? this.state.DocsisSelected.name : undefined,
            }

            this.props.onFilterChange(newFilters)
        } catch (err) {
            return err;
        }
    }
    //#endregion

    //#region INNER COMPONENTS
    // onClick={}
    ApplyFilterComponent = () => {
        const handleSubmit = this.props.handleSubmit;
        return (
            <Grid item container xs={12} justify='center' alignContent='center'>
                <Grid item container xs={12} >
                    <Button className="filters_btn" onClick={this.handleApplyFilters}>Apply Current Filters</Button>
                    <Button className={this.props.isLegacy ? 'Lfilters_clear_btn' : 'filters_clear_btn'} onClick={handleSubmit(this.onSubmitHandler.bind(this))}>Clear All</Button>
                </Grid>
            </Grid>
        )
    }

    FiltersConponent = () => {
        const styles = {
            container: {

            },
            filterContainer: {
                marginTop: '35px',
                borderRadius: '15px',
                border: '1px solid #707070',
            },
            spaceFillerContainer: {
                height: '100px'
            },
            resetFiltersContainer: {
                padding: '25px',
                position: 'relative',
                bottom: '0px',


            }
        }

        return (
            <Grid id='deviceFiltersDrawer' item container className='popOverFilterContainer' alignContent='flex-start' justify='center' style={{ position: 'absolute' }}>
                <Grid item container>
                    <this.TitleComponent />
                </Grid>
                <Grid item container style={{ ...styles.filterContainer }}>
                    <this.ResidentNameFiltersComponent />
                </Grid>
                <Grid item container style={{ ...styles.filterContainer }}>
                    <this.ZoneNamesFilterComponent />
                </Grid>
                <Grid item container style={{ ...styles.filterContainer }}>
                    <this.DocsisFiltersComponent />
                </Grid>
                {
                    !(this.props.isMessagingList === true) ?
                        <Grid item container style={{ ...styles.filterContainer }}>
                            <this.SerialNumberFiltersComponent />
                        </Grid> : ""
                }
                {/* <Grid item container style={{...styles.spaceFillerContainer}}>
                </Grid> */}
                {/* <Grid item style={{...styles.resetFiltersContainer}}>
                    <this.ResetFiltersComponent/>
                </Grid> */}
                <Grid item container xs={12} style={{ ...styles.resetFiltersContainer }}>
                    <this.ApplyFilterComponent />
                </Grid>

            </Grid>
        );
    };

    TitleComponent = () => {
        return (
            <Grid item container>
                <Grid item className={this.props.isLegacy ? 'LpopOverFiltersTitle' : 'popOverFiltersTitle'}>Filters</Grid>
            </Grid>);
    };

    ResidentNameFiltersComponent = () => {
        //This 3 const are for eliminate the duplicate elements in names 
        const residents = this.props.residents ? [...this.props.residents] : []

        const residentsFiltered = [...new Set(residents)]

        const residentsArr = residentsFiltered.map(item => ({ name: item }))

        const residentSelected = this.state.ResidentSelected ? this.state.ResidentSelected : {};

        return (
            <Grid item
                xs={12}
                style={{ paddingLeft: '15px', marginRight: '15px' }}
                justify='center'
                onBlur={() => { this.setState({ openResidentFilterSelect: false }); }}
                onClick={() => { this.setState((prevState) => ({ openResidentFilterSelect: !prevState.openResidentFilterSelect })); }} >
                <LegacySimpleSelect
                    idToSet='legacyDeviceFiltersDrawer_residents'
                    showLabel={true}
                    label={'Resident'}
                    open={this.state.openResidentFilterSelect}
                    onChangeHandler={(evet, newItem) => this.handlerChangeOptionSelectedResidentName(newItem)}
                    optionsItemsIconsData={residentsArr}
                    selected={residentSelected}
                    disabled={false}
                    error={undefined}
                    helperText={undefined}
                    autoFocus={true}
                    stylesObj={{ underline: 'noBorderStyle' }}
                />
            </Grid>
        );
    };

    ZoneNamesFilterComponent = () => {

        //This 3 const are for eliminate the duplicate items of zones 
        const zones = this.props.zoneNames ? [...this.props.zoneNames] : []

        const zonesFiltered = [...new Set(zones)]

        const locations = zonesFiltered.map(item => ({ name: item }))

        const zoneNameSelected = this.state.ZoneNameSelected ? this.state.ZoneNameSelected : {};

        return (
            <Grid item
                xs={12}
                style={{ paddingLeft: '15px', marginRight: '15px' }}
                justify='center'
                onBlur={() => this.setState({ openZoneNameFilterSelect: false })}
                onClick={() => this.setState((prevState) => ({ openZoneNameFilterSelect: !prevState.openZoneNameFilterSelect }))}
            >
                <LegacySimpleSelect
                    idToSet='legacyDeviceFiltersDrawer_locations'
                    showLabel={true}
                    label={'Location'}
                    open={this.state.openZoneNameFilterSelect}
                    onChangeHandler={(evet, newItem) => this.handlerChangeOptionSelectedZoneName(newItem)}
                    optionsItemsIconsData={locations}
                    selected={zoneNameSelected}
                    disabled={false}
                    error={undefined}
                    helperText={undefined}
                    autoFocus={false}
                    stylesObj={{ underline: 'noBorderStyle' }}
                />
            </Grid>
        );
    };


    SerialNumberFiltersComponent = () => {
        const serialNumbers = this.props.serialNumbers ? [...this.props.serialNumbers] : []

        const serialNumbersFiltered = serialNumbers.filter(Boolean);
        const serial = serialNumbersFiltered.map(item => ({ name: item }))
        const SerialNumberSelected = this.state.SerialNumberSelected ? this.state.SerialNumberSelected : {};

        return (
            <Grid item
                xs={12}
                style={{ paddingLeft: '15px', marginRight: '15px' }}
                justify='center'
                onBlur={() => this.setState({ openSerialNumberFilterSelect: false })}
                onClick={() => this.setState((prevState) => ({ openSerialNumberFilterSelect: !prevState.openSerialNumberFilterSelect }))}
            >
                <LegacySimpleSelect
                    idToSet='legacyDeviceFiltersDrawer_device'
                    showLabel={true}
                    label={'Serial Number'}
                    open={this.state.openSerialNumberFilterSelect}
                    onChangeHandler={(evet, newItem) => this.handlerChangeOptionSelectedSerialNumber(newItem)}
                    optionsItemsIconsData={serial}
                    selected={SerialNumberSelected}
                    disabled={false}
                    error={undefined}
                    helperText={undefined}
                    autoFocus={false}
                    stylesObj={{ underline: 'noBorderStyle' }}
                />
            </Grid>
        );
    };

    DocsisFiltersComponent = () => {
        const docsis = this.props.docsis ? [...this.props.docsis] : []

        const docsisFiltered = docsis.filter(Boolean);
        const docsisOptions = docsisFiltered.map(item => ({ name: item }))
        const DocsisSelected = this.state.DocsisSelected ? this.state.DocsisSelected : {};

        return (
            <Grid item
                xs={12}
                style={{ paddingLeft: '15px', marginRight: '15px' }}
                justifyContent='center'
                onBlur={() => this.setState({ openDocsisFilterSelect: false })}
                onClick={() => this.setState((prevState) => ({ openDocsisFilterSelect: !prevState.openDocsisFilterSelect }))}
            >
                <LegacySimpleSelect
                    idToSet='legacyDeviceFiltersDrawer_device'
                    showLabel={true}
                    label={'MAC'}
                    open={this.state.openDocsisFilterSelect}
                    onChangeHandler={(evet, newItem) => this.handlerChangeOptionSelectedDocsis(newItem)}
                    optionsItemsIconsData={docsisOptions}
                    selected={DocsisSelected}
                    disabled={false}
                    error={undefined}
                    helperText={undefined}
                    autoFocus={false}
                    stylesObj={{ underline: 'noBorderStyle' }}
                />
            </Grid>
        );
    };
    ResetFiltersComponent = () => {
        const handleSubmit = this.props.handleSubmit;
        return (
            <Button
                id='deviceFiltersDrawer_resetbtn'
                className='appbtn-engage skybluebtn-engage appbtnBarButton textTransform'
                onClick={handleSubmit(this.onSubmitHandler.bind(this))}
            >
                Reset
            </Button>
        );
    }
    //#endregion




    render() {
        if (this.props.filterObj !== this.state.filterObj) {
            this.setState({ filterObj: this.props.filterObj ? this.props.filterObj : {} }, () => {
                this.renderFilters(this.props.filterObj);
            })
        }

        return (
            <>
                {
                    this.state.anchorEl ?
                        <Popover
                            id="ActivityFilterPopOver"
                            open={true}
                            onClose={this.props.onClose}
                            anchorEl={this.state.anchorEl}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}

                            PaperProps={{
                                className: this.props.isLegacy ? 'LpopOverFilter' : 'popOverFilter' ,
                            }}
                            elevation={3}
                        >
                            <Slide in={true} direction='left' timeout={600} mountOnEnter unmountOnExit>
                                <Grid style={{ height: '100%' }}>
                                    <form>
                                        <this.FiltersConponent />
                                    </form>
                                </Grid>
                            </Slide>
                        </Popover>
                        :
                        undefined
                }

            </>
        )
    }
}

function mapStateToProps(state) {
    const residentsNames = (state.deviceReducer && state.deviceReducer.residents) ? state.deviceReducer.residents : [];
    const locations = (state.deviceReducer && state.deviceReducer.locations) ? state.deviceReducer.locations : [];
    const serials = (state.deviceReducer && state.deviceReducer.serials) ? state.deviceReducer.serials : [];
    const docsis = (state.deviceReducer && state.deviceReducer.docsis) ? state.deviceReducer.docsis : [];
    

    return {
        residentsNames,
        locations,
        serials,
        docsis
    };
};

export default connect(mapStateToProps, { GetDevicesLocations, GetDevicesResidents, GetDevicesSerials, GetDevicesDocsis })(reduxForm({
    form: 'DeviceFiltersForm',
    validate,
})(DeviceFiltersDrawer));
